module.exports = __webpack_public_path__ + "img/coin.e04c6b53.png";